<template>
<div class="error-wrap" :class="{mb: mb}" >
    <span>{{ txt }}</span>
</div>
</template>
<script>

export default {
    name: 'errorwrap',
    props: {
        txt: { type: String, default: '' },
        mb: { type: String, default: '' }
    },
    data() {
        return {
            state: true
        };
    },
    components: {
    },
    methods: {
        changeState(state) {
            this.state = state;
        }
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
.error-wrap {
    position: absolute;
    z-index: 9;
    width: 100%;
    margin-top: 5px;
    &.mb {
        margin-top: (5rem/50);
        span {
            line-height: (14rem/50);
        }
    }
    span {
        position: relative;
        display: block;
        font-size:12px;
        font-family: 'RobotoRegular';
        font-weight: normal;
        color:rgba(248,41,67,1);
        line-height:14px;
    }
}
</style>
